// DayForm.js
import React, { useState } from "react";
import "./DayForm.css";
import { Button } from "react-bootstrap";
import { updateDayApi } from "../../services/educationService";

const DayForm = ({ day, weekId, onClose, weekNumber, onSaveDay }) => {
  const [dayName, setDayName] = useState(day.title || "");
  const [description, setDescription] = useState(day.description || "");

  const handleSave = async () => {
    // TODO: Save logic
    const response = await updateDayApi({
      weekId,
      dayId: day._id,
      title: dayName,
      description,
    });
    onSaveDay(weekId, day._id, response.data);
    onClose();
  };

  const handleDelete = () => {
    // TODO: Delete logic
    onClose();
  };

  return (
    <div className="modal-overlay Edit-day-popup" role="presentation">
      <div
        className="modal-card refined-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-day-title"
      >
        <div className="modal-header">
          <div>
            <h5 className="modal-title" id="edit-day-title">Edit day</h5>
            <p className="modal-context">Week {weekNumber}</p>
          </div>
          <button type="button" onClick={onClose} className="close-btn" aria-label="Close edit day dialog">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-field">
            <label className="modal-label" htmlFor="edit-day-name">Day name</label>
            <input
              id="edit-day-name"
              className="modal-input"
              value={dayName}
              onChange={(e) => setDayName(e.target.value)}
              disabled
            />
          </div>

          <div className="modal-field">
            <label className="modal-label" htmlFor="edit-day-description">Description</label>
            <textarea
              id="edit-day-description"
              className="modal-input textarea"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {day.contentLength > 0 ? (
            <div className="status-label status-label-available" role="status">
              <span className="status-dot green-dot" />
              <span className="status-badge">Content available for this day</span>
            </div>
          ) : (
            <div className="status-label status-label-empty" role="status">
              <span className="status-dot red-dot" />
              <span className="status-badge">No content added yet</span>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <Button type="button" className="btn outlined-btn" onClick={handleDelete}>
            Cancel
          </Button>
          <Button type="button" className="btn filled-btn" onClick={handleSave}>
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DayForm;
